export const TEXT_ANIMATION_DELAY_IN_MS = 2000;
